export const settingTypes = [
  { label: 'Object field', value: 'object-field' },
  { label: 'Reservation value', value: 'reservation' },
  { label: 'Plain text value', value: 'text' },
];
